/**
 * 课时直绑高亮：课时名前 GIF。整课已购 / 免登录整课不展示。
 */
// 功能：是否展示课时直绑 GIF；类型：新增；时间：2026-08-19 16:35:00
// 范围：showPeriodUserAuthGif
// 思路：认 periodUserAuth；buyStatus / 免登录覆盖时不展示
export const showPeriodUserAuthGif = (period, info) => {
  // 1. 无课时直绑标记则不展示
  if (!period?.periodUserAuth) {
    return false
  }
  // 2. 整课已购或免登录整课不展示
  if (info?.buyStatus || info?.noLoginWatch || info?.partNoLoginWatch) {
    return false
  }
  return true
}
